// BotonFlotante.js
import React from 'react';
import './BotonFlotante.css';

import bg from '../../assets/img/RBS_element2.png'
import imglibro from '../../assets/img/RBS_element1.png'
import RbsLottie from '../lotties/rbs-cta';

import { useTranslation } from 'react-i18next';

const BotonFlotante = () => {

  const [t, i18n] = useTranslation("home");
  const liga_lang3 = '/' + i18n.language + "/LibroBitcoin";

  return (
    <a href={liga_lang3}>
      <div className="boton-flotante">
        <div className="rbs-lottie">
          <img src={imglibro}/>
        </div>
        <img src={bg} alt="Imagen ideas" class="imgG2_bi " />
        <div className="texto-contenedor">
          <span className='span1'>{i18n.language === 'es' ? '¡Conoce mi libro' : 'Discover my book'}</span>
          <span className='span2'>{i18n.language === 'es' ? 'sobre Bitcoin!' : 'on Bitcoin!'}</span>
        </div>

      </div>
    </a>

  );
}

export default BotonFlotante;
